import * as XLSX from 'xlsx';

export const useExcelExport = () => {
  const exportToExcel = (data, fileName = 'export') => {
    // Validate data
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }

    try {
      // Create workbook
      const workbook = XLSX.utils.book_new();

      // Convert data to sheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Set column widths (20 characters each)
      worksheet['!cols'] = Object.keys(data[0]).map(() => ({ wch: 20 }));

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

      // Write file
      XLSX.writeFile(workbook, `${fileName}_${new Date().getTime()}.xlsx`);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data');
    }
  };

  return { exportToExcel };
};